import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { MonitorRejectionLocalStore } from 'components/app/_mediator/localstore/hooks/use-api';
import { LocalStore } from 'constants/localstore';

export const MonitorRejectionToast = () => {
  useEffect(() => {
    const monitorRejection = localStorage.getItem(LocalStore.monitorRejection);
    if (monitorRejection) {
      localStorage.removeItem(LocalStore.monitorRejection);
      const data = JSON.parse(monitorRejection) as MonitorRejectionLocalStore;
      toast.error(
        <div>
          <h3>{data.err}</h3>
          <p>Rejected actions:</p>
          <ul>
            {data.actions.map((action, i) => (
              <li key={i}>{action}</li>
            ))}
          </ul>
        </div>
      );
    }
  }, []);

  return <ToastContainer />;
};
